import { Tbody, type StackProps } from '@chakra-ui/react';

export type UiTbodyProps = StackProps;

export const UiTbody = Tbody;
